import { useTranslation, UseTranslationResponse } from 'react-i18next';
import { i18nextNamespace } from '../Editor.utils';

export function useEditorTranslation(): UseTranslationResponse<typeof i18nextNamespace, ''> {
  return useTranslation(i18nextNamespace);
}
